import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import TreeViewItemText from './tree-view-item-text';
import TreeViewItemIcon from './tree-view-item-icon';
import TreeViewItemActions from './tree-view-item-actions';
import { TYPES } from '../../../icon/constants';
import noop from '../../../../../utils/noop';

const defaultActions = [];

const TreeViewItem = ({
  title,
  iconGlyph,
  customIconGlyph = null,
  hoverIconGlyph = undefined,
  iconType = TYPES.default,
  selected = false,
  disabled = false,
  onClick = noop,
  description = '',
  actions = defaultActions,
  isEmpty = false,
  draggable = true,
  isDragging = false,
  highlighted = false,
}) => {
  const isMobile = bowser.mobile;
  const isTouchDevice = bowser.mobile || bowser.tablet;

  const classes = classNames('ws-ui-tree-view-item', {
    'ws-ui-tree-view-item--disabled': disabled,
    'ws-ui-tree-view-item--selected': selected,
    'ws-ui-tree-view-item--mobile': isMobile,
    'ws-ui-tree-view-item--touch-device': isTouchDevice,
    'ws-ui-tree-view-item--is-empty': isEmpty,
    'ws-ui-tree-view-item--is-dragging': isDragging,
    'ws-ui-tree-view-item--draggable': draggable,
    'ws-ui-tree-view-item--highlighted': highlighted,
  });

  return (
    <div className={classes} onClick={onClick}>
      <div className="ws-ui-tree-view-item__content">
        <TreeViewItemIcon
          iconGlyph={iconGlyph}
          customIconGlyph={customIconGlyph}
          hoverIconGlyph={hoverIconGlyph || iconGlyph}
          iconType={iconType}
          disabled={disabled}
        />
        <TreeViewItemText title={title} description={description} />
      </div>
      <TreeViewItemActions actions={actions} disabled={disabled} />
    </div>
  );
};

export default TreeViewItem;
